import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../sections/Navbar';
import Footer from '../sections/Footer';
import trainingData from '../data/training.json';

const TrainingScreen = () => {
  const programs = Object.values(trainingData.programs);

  return (
    <>
      <Navbar />
      <div className="training-page-container">
        <header className="form-page-header">
          <h1>Our Training Programs</h1>
          <p>From home enthusiast to seasoned professional, our courses are designed to elevate your craft.</p>
        </header>
        
        <div className="program-cards-container">
          {programs.map(program => (
            <Link key={program.id} to={`/training/${program.id}`} className="program-card">
              <img src={program.image} alt={program.title} className="program-card-bg" />
              <div className="program-card-overlay"></div>
              <div className="program-card-content">
                <h2>{program.title}</h2>
                <p>{program.description}</p>
                <span>Explore Program &rarr;</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TrainingScreen;